<template>
    <div v-if="!isLogin">
        <ConsentRegister :nextPage="nextPage" :isStandard="true"></ConsentRegister>
    </div>
</template>
<script>
//component
import ConsentRegister from "@/module/ConsentRegister/page/ConsentRegister.vue"
import { useTracking } from "@/feature/TrackingFeature"
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";

export default {
    name: "NewRegisterPage",
    mixins:[AuthStatusMixin],
    components: {
        ConsentRegister,
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            nextPage: "/newregister/form",
        }
    },
    created: function() {
        this.tracking.screenName('register_standard')
        this.tracking.event("register_standard_page", "view_terms_cons", "", "");

        let query = this.$route.fullPath.split('?')
        if (query.length > 1) {
            let queryStr = query[1]
            this.nextPage = this.nextPage + '?' + queryStr
        }
        if (this.isLogin) {
            window.location.replace("/newregister/success")
        }
    },
    methods: {
    },
}
</script>

